import moment from "moment";
import React from "react";
import { GiCheckMark } from "react-icons/gi";

const AllSet = ({ onClose }) => {
  return (
    <>
      <div className="flex items-center justify-center bg-primary100 w-12 min-w-12 h-12 min-h-12 rounded-full">
        <GiCheckMark className="p-0.5 text-primary700" />
      </div>

      <div className="text-2xl font-bold text-black mt-2">All set!</div>

      <div className="text-base text-grayTrue700 mt-2">
        Subscription will auto-renew monthly, starting{" "}
        {moment().add(1, "months").format("MM/DD")}
      </div>

      <button
        onClick={onClose}
        className="w-full min-h-11 h-11 rounded-full font-semibold text-sm btnGray100 mt-2"
      >
        Close
      </button>
    </>
  );
};

export default AllSet;
